<template>
    <div class="row">
        <div
            v-for="(n, index) in 7"
            :key="index"
            :style="getDayStyle(index)"
            :class="getDayClass(index)"
        />
    </div>
</template>

<script>
export default {
    name: 'WeekGraph',
    data() {
        return {
            weekdays: [
                { id: 1, name: 'Sunday',    color: 'red',    border: 'red' },
                { id: 2, name: 'Monday',    color: 'orange', border: 'orange' },
                { id: 3, name: 'Tuesday',   color: 'yellow', border: 'yellow' },
                { id: 4, name: 'Wednesday', color: 'green',  border: 'green' },
                { id: 5, name: 'Thursday',  color: 'blue',   border: 'blue' },
                { id: 6, name: 'Friday',    color: 'black',  border: 'black' },
                { id: 7, name: 'Saturday',  color: 'white',  border: 'black' },
            ],
        }
    },
    methods: {
        getDayStyle(index) {
            const { color, border } = this.weekdays[index]
            const textColor = index === 6 ? 'black' : 'white'
            return `background-color:${color}; padding:5px; color:${textColor}; border:1px solid ${border}; opacity:0.62`
        },
        getDayClass(index) {
            return (index + 1 === 6 || index + 1 === 7) ? 'col-md-1 col-sm-1 col-1' : 'col-md-2 col-sm-2 col-2'
        },
    },
}
</script>

<style scoped></style>
